module.exports = __webpack_public_path__ + "static/media/ic-bulk-update.587295db.svg";